/* ============================================================
   VEYRAN Scroll Film — scroll-scrubbed video (OCEAN-style).
   Desktop: pin section, map scroll progress to video.currentTime.
   Mobile / no GSAP / no video: graceful fallbacks, never breaks page.
   Independent file, safe to remove.
   ============================================================ */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isMobile = window.matchMedia('(max-width: 768px)').matches;

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function clampT(t) {
    var v = document.querySelector('.vy-scrollfilm__video');
    var d = (v && v.duration && isFinite(v.duration)) ? v.duration : 0;
    if (!d) return 0;
    var lo = 0.12, hi = d - 0.18;
    if (hi < lo) hi = lo;
    if (t < lo) return lo;
    if (t > hi) return hi;
    return t;
  }

  function forceAutoplay(video, maxAttempts) {
    maxAttempts = maxAttempts || 4;
    var attempts = 0;
    try { video.muted = true; } catch (e) {}
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.loop = true;
    try { video.load(); } catch (e) {}
    var tryPlay = function () {
      attempts++;
      try {
        var p = video.play();
        if (p && p.then) {
          p.then(function () {}).catch(function () {
            if (attempts < maxAttempts) setTimeout(tryPlay, 1200);
          });
        }
      } catch (e) {
        if (attempts < maxAttempts) setTimeout(tryPlay, 1200);
      }
    };
    if (video.readyState >= 2) { tryPlay(); }
    else {
      video.addEventListener('canplay', tryPlay, { once: true });
      setTimeout(tryPlay, 2500);
    }
  }

  function initScrollFilm() {
    try {
      var section = document.querySelector('.vy-scrollfilm');
      if (!section) return;
      var pin = section.querySelector('.vy-scrollfilm__pin');
      var video = section.querySelector('.vy-scrollfilm__video');

      // No video configured: nothing to scrub, placeholder animates via CSS.
      if (!video) return;

      // Respect reduced motion: play normally, no scrub.
      if (reduceMotion) {
        video.setAttribute('loop', '');
        video.play().catch(function () {});
        return;
      }

      // Mobile: scrubbing is janky on touch — autoplay loop instead.
      if (isMobile || !(window.gsap && window.ScrollTrigger)) {
        forceAutoplay(video, 4);
        return;
      }

      gsap.registerPlugin(ScrollTrigger);

      // Pause native playback; we drive time manually.
      video.pause();

      var scrubLen = 300; // default, matches schema
      var rangeEl = section.querySelector('[data-scrub-length]');
      if (rangeEl) scrubLen = parseInt(rangeEl.getAttribute('data-scrub-length'), 10) || 300;

      function duration() {
        return video.duration && isFinite(video.duration) ? video.duration : 0;
      }

      ScrollTrigger.create({
        trigger: section,
        start: 'top top',
        end: '+=' + scrubLen + '%',
        pin: pin,
        scrub: 0.6,
        anticipatePin: 1,
        invalidateOnRefresh: true,
        onUpdate: function (self) {
          var d = duration();
          if (!d || video.readyState < 2) return;
          var t = clampT(self.progress * d);
          try {
            if (Math.abs(video.currentTime - t) > 0.06) video.currentTime = t;
          } catch (e) {}
        },
        onLeave: function () {
          try { video.currentTime = clampT(dur()); } catch (e) {}
        },
        onLeaveBack: function () {
          try { video.currentTime = clampT(0); } catch (e) {}
        }
      });

      // Preload enough for smooth scrub; refresh triggers once metadata lands.
      function prime() {
        try { ScrollTrigger.refresh(); } catch (e) {}
        try { if (video.readyState >= 2) video.currentTime = clampT(0); } catch (e) {}
      }
      video.addEventListener('loadedmetadata', prime);
      video.addEventListener('canplay', function () {
        try { video.currentTime = clampT(video.currentTime || 0); } catch (e) {}
      });
      if (video.readyState >= 1) prime();
      try { video.load(); } catch (e) {}
      window.addEventListener('load', function () {
        try { ScrollTrigger.refresh(); } catch (e) {}
      });
    } catch (err) {
      /* never break the page */
    }
  }

  // Video error fallback: show animated placeholder instead of black.
  function initVideoFallback() {
    try {
      var video = document.querySelector('.vy-scrollfilm__video');
      if (!video) return;
      video.addEventListener('error', function () {
        try {
          var ph = document.createElement('div');
          ph.className = 'vy-scrollfilm__placeholder';
          ph.setAttribute('aria-hidden', 'true');
          video.parentNode.insertBefore(ph, video);
          video.style.display = 'none';
        } catch (e) {}
      }, true);
    } catch (e) {}
  }

  // Hero video: force mobile autoplay.
  function initHeroVideo() {
    try {
      if (!window.matchMedia('(max-width: 768px)').matches) return;
      var vids = document.querySelectorAll('video:not(.vy-scrollfilm__video)');
      for (var i = 0; i < vids.length; i++) {
        (function (v) {
          var el = v, heroish = false;
          while (el && el !== document.body) {
            var c = (el.className || '').toString().toLowerCase();
            if (c.indexOf('hero') !== -1 || c.indexOf('banner') !== -1) { heroish = true; break; }
            el = el.parentNode;
          }
          if (heroish) forceAutoplay(v, 4);
        })(vids[i]);
      }
    } catch (e) {}
  }

  onReady(function () {
    initVideoFallback();
    initScrollFilm();
    initHeroVideo();
  });
})();
